<script>
    import page from "../components/page.vue";
    
    export default {
        components: {
            page,
        },
    };
</script>

<template lang="pug">
    page
        h1 Error 404 Not Found
        p The requested path is not available.
</template>



// WEBPACK FOOTER //
// src/pages/Error404.vue